<script setup>
import { ref } from 'vue'

const iframeSrc = ref('https://internal-service.officedesign.co.th/admin/insights/64e12a1c-0bc2-4913-aa1c-cc5f03fb68a2?access_token=CjoJhAgVnNvOw-AQBwbRvYOu78CbuxcU')
</script>

<template>
    <iframe
        :src="iframeSrc"
        style="position:fixed; top:0; left:0; width:100vw; height:100vh; border:none; margin:0; padding:0; overflow:hidden; z-index:999999;"
        frameborder="0" title="Embedded Page"></iframe>
</template>